<div class="p-3 border">
    <span *ngFor="let item of breadcrumbService.breadcrumbs; let index=index">  
        <a *ngIf="index !== breadcrumbService.breadcrumbs.length-1" [routerLink]="item.url">{{ item.title }}</a>
        <span *ngIf="index !== breadcrumbService.breadcrumbs.length-1"> / </span>
        <span *ngIf="index == breadcrumbService.breadcrumbs.length-1"> {{ item.title }} </span>
    </span>
</div>